import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestoperacaobloqueioprefaturageradaitem({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(
      api.get,
      'operacaobloqueioprefaturageradaitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* veiculosBloqueadosPreFaturaGeradaInRequest({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(
      api.get,
      'operacaobloqueioprefaturageradaitemhistoricoitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteoperacaobloqueioprefaturageradaitem({ payload }) {
  try {
    const { fatu_codigo, params } = payload;

    yield call(
      api.delete,
      `operacaobloqueioprefaturageradaitem/${fatu_codigo}`
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaobloqueioprefaturageradaitem, params } = payload;

    yield call(
      api.post,
      'operacaobloqueioprefaturageradaitem',
      operacaobloqueioprefaturageradaitem
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaobloqueioprefaturageradaitem/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* findVeiculo({ payload }) {
  try {
    const { fatu_codigo } = payload;

    const { data } = yield call(
      api.get,
      `operacaobloqueioprefaturageradaitemhistoricoitem/${fatu_codigo}`
    );

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaobloqueioprefaturageradaitem, params } = payload;

    yield call(
      api.put,
      'operacaobloqueioprefaturageradaitem',
      operacaobloqueioprefaturageradaitem
    );
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculobloqueiofaturamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(
      api.get,
      'operacaobloqueioprefaturageradaitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFiltersVeiculo({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(
      api.get,
      'operacaobloqueioprefaturageradaitemhistoricoitem',
      {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      }
    );

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}
//operacaobloqueioveiculoprefaturas
//OPERACAO
export default all([
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/BLOQUEIOVEICULOS_IN_REQUEST',
    requestoperacaobloqueioprefaturageradaitem
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/DELETE_BLOQUEIOVEICULOS',
    deleteoperacaobloqueioprefaturageradaitem
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/SUCCESS_REMOVE',
    requestoperacaobloqueioprefaturageradaitem
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/STORE_BLOQUEIOVEICULOS',
    store
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/FIND_BLOQUEIOVEICULOS',
    find
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/FIND_VEICULOSPREGERADA',
    findVeiculo
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/UPDATE_BLOQUEIOVEICULOS',
    update
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING',
    applyedFilters
  ),
  takeLatest(
    '@operacaobloqueioprefaturageradaitem/RECORD_FILTERING_VEICULO',
    applyedFiltersVeiculo
  ),
]);
